let concurrentMode = false;
export const setConcurrentMode = (mode) => {
    concurrentMode = mode;
};
export const isConcurrentMode = () => concurrentMode;
export const isTest = () => process.env.NODE_ENV === 'test';
export const isLocalDb = () => {
    const nodeEnv = process.env.NODE_ENV;
    const dbEnv = process.env.DB_ENV;
    return (nodeEnv === 'test' || nodeEnv === 'development') && (dbEnv === 'emptylocaldb' || dbEnv === 'localdb');
};
export const isTestOrLocalDb = () => {
    const nodeEnv = process.env.NODE_ENV;
    const dbEnv = process.env.DB_ENV;
    return nodeEnv === 'test' || (nodeEnv === 'development' && (dbEnv === 'emptylocaldb' || dbEnv === 'localdb'));
};
export const isEmptyLocalDb = () => {
    const nodeEnv = process.env.NODE_ENV;
    const dbEnv = process.env.DB_ENV;
    return (nodeEnv === 'test' || nodeEnv === 'development') && dbEnv === 'emptylocaldb';
};
export const isProduction = () => process.env.NODE_ENV === 'production';
export const localDbLocation = () => process.env.COMMUNICATE_LOCALDB_LOCATION || process.env.HOME || '';
//# sourceMappingURL=envious-envs.js.map